// frontend/src/LawRoutes.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import necessary pages
import Search from './pages/Search';
import Contribute from './pages/Contribute';
// Import protected law pages...
import CriminalLaw from './pages/CriminalLaw';
import CivilLaw from './pages/CivilLaw';
import LabourLaw from './pages/LabourLaw';
import CorporateLaw from './pages/CorporateLaw';
import FamilyLaw from './pages/FamilyLaw';
import ConsumerLaw from './pages/ConsumerLaw';

const LawRoutes = () => {
  const auth = localStorage.getItem('token');

  return (
    <Routes>
      {/* <Route path="/search" element={<Search />} /> Search route */}
      <Route path="/contribute" element={auth ? <Contribute /> : <Navigate to="/login" />} /> {/* Contribute route */}
      <Route path="/search" element={auth ? <Search /> : <Navigate to="/login" />} /> {/* Contribute route */}
      
      {/* Protected law pages */}
      <Route path="/criminal-law" element={auth ? <CriminalLaw /> : <Navigate to="/login" />} />
      <Route path="/civil-law" element={auth ? <CivilLaw /> : <Navigate to="/login" />} />
      <Route path="/corporate-law" element={auth ? <CorporateLaw /> : <Navigate to="/login" />} />
      <Route path="/Labour-Law" element={auth ? <LabourLaw /> : <Navigate to="/login" />} />
      <Route path="/family-law" element={auth ? <FamilyLaw /> : <Navigate to="/login" />} />
      <Route path="/consumer-law" element={auth ? <ConsumerLaw /> : <Navigate to="/login" />} />
      
      {/* Redirect any unknown routes to home */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default LawRoutes;
